import * as React from "react";
import Typography from "@mui/material/Typography";
import { Box, Divider, Icon } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CGI_GREY, CGI_RED, CGI_WHITE } from "../helpers/enums";
import CGILogo from "../images/general/CGI_logo_color_rgb.svg";

export default function Copyright() {
  const { t } = useTranslation();

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        bottom: 0,
        bgcolor: CGI_GREY,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: 1,
          py: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ml: 3,
          }}
        >
          <Typography
            sx={{ fontSize: 15, userSelect: "none", color: CGI_WHITE }}
          >
            a solution by
          </Typography>
          <Icon sx={{ width: 80, height: 50 }}>
            <img draggable={false} src={CGILogo} />
          </Icon>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: 15,
          }}
        >
          <Typography
            align="right"
            color={CGI_WHITE}
            sx={{ userSelect: "none", justifySelf: "center" }}
          >
            {new Date().getFullYear() + " CGI Inc."}
          </Typography>
          <Divider
            orientation="vertical"
            sx={{ mx: 1, height: 1, borderColor: CGI_WHITE }}
          />
          <Typography
            onClick={() =>
              window.open("https://www.cgi.com/de/de/impressum", "_blank")
            }
            color={CGI_WHITE}
            sx={{
              userSelect: "none",
              justifySelf: "center",
              "&:hover": {
                cursor: "pointer",
                color: CGI_RED,
              },
            }}
          >
            {t("legalNotice")}
          </Typography>
          <Divider
            orientation="vertical"
            sx={{ mx: 1, height: 1, borderColor: CGI_WHITE }}
          />
          <Typography
            onClick={() =>
              window.open(
                "https://www.cgi.com/de/de/datenschutz/datenschutzrichtlinie",
                "_blank"
              )
            }
            color={CGI_WHITE}
            sx={{
              userSelect: "none",
              justifySelf: "center",
              "&:hover": {
                cursor: "pointer",
                color: CGI_RED,
              },
            }}
          >
            {t("dataPrivacy")}
          </Typography>
          {/* <Divider
            orientation="vertical"
            sx={{ mx: 1, height: 1, borderColor: {CGI_BLACK} }}
          />
          <Typography
            onClick={() => openInNewTab("https://support.cgicompass.com")}
            color={CGI_BLACK}
            sx={{
              userSelect: "none",
              justifySelf: "center",
              "&:hover": {
                cursor: "pointer",
                color: "#000",
              },
            }}
          >
            Support
          </Typography> */}
        </Box>
      </Box>
    </Box>
  );
}
